const truthyDemo = (value) =>
  value === true ||
  value === 1 ||
  value === '1' ||
  value === 'true' ||
  value === 'TRUE';

export const isDemoMode = (salon) =>
  truthyDemo(salon?.demoMode) || truthyDemo(salon?.demo_mode);

const readSalonsFromStorage = () => {
  try {
    const salons = JSON.parse(localStorage.getItem('salons') || '[]');
    return Array.isArray(salons) ? salons : [];
  } catch {
    return [];
  }
};

/** Solo il salone indicato (o quello isActive). Mai il primo della lista. */
export const findSalonInStorage = (salonId) => {
  const list = readSalonsFromStorage();
  if (salonId != null && salonId !== '') {
    return list.find((salon) => +salon.idsalone === +salonId) || null;
  }
  return list.find((salon) => salon?.isActive) || null;
};

export const readDemoModeFromStorage = (salonId) => isDemoMode(findSalonInStorage(salonId));

export const storageMissingDemoFlag = () => {
  const list = readSalonsFromStorage();
  if (!list.length) return false;
  return list.some(
    (salon) => salon && salon.demoMode === undefined && salon.demo_mode === undefined,
  );
};

export const isDemoEntityId = (id) => {
  const n = Number(id);
  return Number.isFinite(n) && n < 0;
};
